module.exports = __webpack_public_path__ + "img/3d-models-icon.fc03368b.svg";